const defaultHeadersObject = {
    Accept: 'application/vnd.api+json, application/json',
} as const;

export const defaultOptions: RequestInit = {
    credentials: 'same-origin',
    headers: defaultHeadersObject,
};

export const defaultHeaders = new Headers(defaultHeadersObject);
